<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Select Times'"
    [canGoBack]="false"
    closeIconDesktop="arrow-back-black"
    closeIconMobile="arrow-back-white"
    (closeItemAction)="closeModal()"
    id="top-nav-height">
    <tidy-wrapper>
      <tidy-row>
        <tidy-divider />
      </tidy-row>

      <tidy-grid>
        <ion-row>
          <ion-col size="10">
            <tidy-row class="vertical-align-center">
              <tidy-image
                class="body-size"
                [src]="'assets/img/icons/number_1_white.svg'" />
              <tidy-text
                [actionBody]="frequencyLabel | titlecase"
                class="white" />
            </tidy-row>
            <tidy-row class="vertical-align-center">
              <tidy-image
                class="body-size"
                [src]="'assets/img/icons/number_2_white.svg'" />
              <tidy-text
                [actionBody]="firstTime | titlecase"
                class="white" />
            </tidy-row>
            <tidy-row class="vertical-align-center">
              <tidy-image
                class="body-size"
                [src]="'assets/img/icons/number_3_white.svg'" />
              <tidy-text
                [actionBody]="secondDateLabelText | titlecase"
                class="white" />
            </tidy-row>
            @if (thriceAWeek) {
              <tidy-row class="vertical-align-center">
                <tidy-image
                  class="body-size"
                  [src]="'assets/img/icons/number_4_white.svg'" />
                <tidy-text
                  [actionBody]="thirdDateLabelText | titlecase"
                  class="white" />
              </tidy-row>
            }
          </ion-col>
          <ion-col size="2" class="vertical-align-center">
            <tidy-row class="extra-left-padding">
              <tidy-text
                [title]="(selectedPrice | tcurrency)"
                class="text-price" />
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-grid>

      <tidy-button
        [text]="'Confirm Selected Times'"
        [action]="boundConfirmSelections"
        [disabled]="!isFormValidState"
        class="primary" />

    </tidy-wrapper>
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper>
      <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

      @if (!closeSecondTime) {
        <tidy-row>
          <tidy-text
            [title]="'Select Second Time'" />
        </tidy-row>
        @for (item of dateTimes; track item; let idx = $index) {
          <tidy-card>
            <tidy-row>
              <tidy-text
                [header]="item.date | parseDateTime:'dddd MMM d':''" />
            </tidy-row>
            <tidy-row>
              <tidy-radio-button
                chunkSize="3"
                formControlName="second_time"
                (optionChange)="selectSecondTime($event, idx)"
                [form]="form.controls.second_time"
                [(ngModel)]="form.value.second_time"
                [items]="item.times" />
            </tidy-row>
          </tidy-card>
        }
      }

      @if (thriceAWeek && closeSecondTime) {
        <tidy-row>
          <tidy-text
            [title]="'Select Third Time'" />
        </tidy-row>
        @for (item of dateTimes; track item) {
          <tidy-card>
            <tidy-row>
              <tidy-text
                [header]="item.date | parseDateTime:'dddd MMM d':''" />
            </tidy-row>
            <tidy-row>
              <tidy-radio-button
                chunkSize="3"
                formControlName="third_time"
                (optionChange)="selectThirdTime($event)"
                [form]="form.controls.third_time"
                [(ngModel)]="form.value.third_time"
                [items]="item.times" />
            </tidy-row>
          </tidy-card>
        }
      }

    </tidy-wrapper>
  </form>
</ng-template>

<app-scroll-wrapper [style.padding-top.px]="topNavHeight" [templateContent]="content" />
